import React, { useEffect, useState } from "react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import DataTable from "../components/DataTable";
import { Badge } from "../components/ui/badge";
import SeverityBadge from "../components/SeverityBadge";
import { formatIDR, formatPercent, formatDate } from "../lib/format";

export default function Collaterals() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/collaterals").then((r) => setData(r.data)).finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- load once on mount

  return (
    <div className="p-8 max-w-[1600px] mx-auto" data-testid="collaterals-page">
      <PageHeader title="Collateral" subtitle={`${data.length} jaminan terdaftar`} />
      {loading ? <div className="text-sm text-muted-foreground">Memuat…</div> : (
        <DataTable
          testId="collaterals-table"
          searchKeys={["collateral_id", "collateral_type", "owner_name"]}
          columns={[
            { header: "Collateral ID", cell: (r) => <span className="mono">{r.collateral_id}</span> },
            { header: "Tipe", key: "collateral_type" },
            { header: "Pemilik", cell: (r) => <span className="text-xs">{r.owner_name}</span> },
            { header: "Market Value", cell: (r) => formatIDR(r.market_value, { compact: true }), align: "right" },
            { header: "Haircut", cell: (r) => formatPercent(r.haircut, 0), align: "right" },
            { header: "Lendable", cell: (r) => formatIDR(r.lendable_value, { compact: true }), align: "right" },
            { header: "Expiry", cell: (r) => {
              const exp = new Date(r.expiry_date);
              const expired = exp < new Date();
              return <span className={`mono text-xs ${expired ? "text-[#D0021B] font-bold" : ""}`}>{formatDate(r.expiry_date)}{expired ? " (EXP)" : ""}</span>;
            } },
            { header: "Fasilitas Terkait", cell: (r) => (
              <div className="flex flex-wrap gap-1">
                {(r.facility_ids || []).slice(0, 3).map((fid) => <Badge key={fid} variant="outline" className="mono text-[10px]">{fid}</Badge>)}
                {r.facility_ids?.length > 3 && <span className="text-xs text-muted-foreground">+{r.facility_ids.length - 3}</span>}
                {r.facility_ids?.length > 1 && <SeverityBadge severity="info">SHARED</SeverityBadge>}
              </div>
            ) },
          ]}
          data={data}
        />
      )}
    </div>
  );
}
